import { render, staticRenderFns } from "./AMSOperateLogs.vue?vue&type=template&id=a972a290&"
import script from "./AMSOperateLogs.vue?vue&type=script&lang=ts&"
export * from "./AMSOperateLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports